import React from 'react';

function ErrorBoundaryTemplate() {
    return (
        <h1>Something went wrong</h1>
    )
}

export default ErrorBoundaryTemplate;